import React from 'react';
import Modal from '../../../shared/_Modal';
import { APPOINTMENT_FREQUENCY_LIMIT } from '../../../../constants/messages';
import { connect } from 'react-redux';
import { tooltipHide } from '../../../../actions/tooltipActions';
import { Button } from '../../../shared/_form';
import PropTypes from 'prop-types';

const FreguencyLimitModal = ({ id, hideModal }) => {
  function _handleCloseModal() {
    hideModal(id);
  }

  return (
    <Modal id={ id }>
      <div className='modal__header'>
        {APPOINTMENT_FREQUENCY_LIMIT.header}
      </div>
      <div>
        {APPOINTMENT_FREQUENCY_LIMIT.body}
        <div className='modal__actions'>
          <Button className='form__button form__button--green rep-apts-index__book-modal__button'
            onClick={ _handleCloseModal }
            type='button'>
          Close
          </Button>
        </div>
      </div>
    </Modal>);
};
const mapDispatchToProps = (dispatch) => ({
  hideModal: (id) => dispatch(tooltipHide({ id: id }))
});

FreguencyLimitModal.propTypes = {
  hideModal: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(FreguencyLimitModal);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/offers/FrequencyLimitModal.jsx